import { createRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';
import { rootRoute } from '@/router/root-route';
import ProgramEditPage from '@/features/programs/program-edit/ProgramEditPage';
import {
  ProgramByIdFetchError,
  programByIdQueryOptions,
} from '@/features/programs/program-edit/program-by-id-query';

const editSearchSchema = z.object({
  copy: z.boolean().optional(),
});

export const programEditRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/programas/$programId/editar',
  component: ProgramEditPage,
  validateSearch: editSearchSchema,
  // RN-15: a missing / removed / out-of-scope program (GET /programs/:id → 404)
  // must bounce the consultor back to the listing, not surface the router's
  // "Something went wrong! — Failed to load program" error boundary.
  loader: async ({ context, params }) => {
    try {
      await context.query.ensureQueryData(programByIdQueryOptions(params.programId));
    } catch (err) {
      if (err instanceof ProgramByIdFetchError && err.status === 404) {
        throw redirect({ to: '/programas', replace: true });
      }
      throw err;
    }
  },
});
